var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 133.333,
    width: 133.333,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 100h100V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 133.333)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M0 0v40.356a3.321 3.321 0 0 0 3.32 3.321h25.124a3.322 3.322 0 0 0 3.321-3.321V0",
    transform: "translate(9.97 3)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M0 0v42.68A3.32 3.32 0 0 0 3.32 46h39.683a3.32 3.32 0 0 0 3.32-3.32V14.897",
    transform: "translate(28.5 47)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M0 0v56.238a3.32 3.32 0 0 0 3.32 3.321h43.654a3.32 3.32 0 0 0 3.32-3.321V0",
    transform: "translate(41.735 3)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.362a1.951 1.951 0 0 0-1.951 1.951V9.96c0 1.078.873 1.952 1.951 1.952H0A1.951 1.951 0 0 0 1.951 9.96V1.951A1.951 1.951 0 0 0 0 0",
    transform: "translate(46.402 71.824)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.362a1.951 1.951 0 0 0-1.951 1.951V9.96c0 1.078.873 1.952 1.951 1.952H0A1.952 1.952 0 0 0 1.951 9.96V1.951A1.952 1.952 0 0 0 0 0",
    transform: "translate(62.284 71.824)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.362a1.95 1.95 0 0 0-1.951 1.951V9.96c0 1.078.873 1.952 1.951 1.952H0A1.952 1.952 0 0 0 1.951 9.96V1.951A1.951 1.951 0 0 0 0 0",
    transform: "translate(62.284 37.412)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.361a1.951 1.951 0 0 0-1.952 1.951V9.96c0 1.078.874 1.952 1.952 1.952H0A1.951 1.951 0 0 0 1.951 9.96V1.951A1.95 1.95 0 0 0 0 0",
    transform: "translate(78.166 37.412)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.362a1.951 1.951 0 0 0-1.951 1.951v8.01c0 1.077.873 1.951 1.951 1.951H0a1.952 1.952 0 0 0 1.951-1.951v-8.01A1.952 1.952 0 0 0 0 0",
    transform: "translate(62.284 21.53)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.362a1.951 1.951 0 0 0-1.951 1.951v8.01c0 1.077.873 1.951 1.951 1.951H0a1.951 1.951 0 0 0 1.951-1.951v-8.01A1.951 1.951 0 0 0 0 0",
    transform: "translate(30.52 25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.362a1.951 1.951 0 0 0-1.951 1.952v8.009a1.95 1.95 0 0 0 1.951 1.951H0a1.95 1.95 0 0 0 1.951-1.951V1.952A1.951 1.951 0 0 0 0 0",
    transform: "translate(30.52 9.617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.361a1.952 1.952 0 0 0-1.952 1.951v8.01c0 1.077.874 1.951 1.952 1.951H0a1.951 1.951 0 0 0 1.951-1.951v-8.01A1.951 1.951 0 0 0 0 0",
    transform: "translate(78.166 21.53)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.362a1.95 1.95 0 0 0-1.951 1.951V9.96a1.95 1.95 0 0 0 1.951 1.951H0A1.951 1.951 0 0 0 1.951 9.96V1.951A1.951 1.951 0 0 0 0 0",
    transform: "translate(62.284 5.647)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-5.361a1.951 1.951 0 0 0-1.952 1.951V9.96c0 1.078.874 1.951 1.952 1.951H0A1.95 1.95 0 0 0 1.951 9.96V1.951A1.95 1.95 0 0 0 0 0",
    transform: "translate(78.166 5.647)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCity);
export default __webpack_public_path__ + "static/media/search-city.7604eeadcd93c35ff4cb018847e5a83a.svg";
export { ForwardRef as ReactComponent };